
import { supabase } from './supabase';

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
    //console.log('Starting request', config.url, config.method);
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers['Authorization'] = `Bearer ${session.access_token}`;
      //console.log('Added Authorization header:', config.headers['Authorization']);
    } else {
      console.warn('No access token available');
    }
    //console.log('Request headers:', config.headers);
    return config;
  }, (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  });
  
  // Add response interceptor
  api.interceptors.response.use(
    (response) => {
      console.log('Response:', response.status, response.data);
      return response;
    },
    (error) => {
      console.error('Response error:', error.response ? error.response.status : 'No response', error.message);
      return Promise.reject(error);
    }
  );

  export const checkDomainAvailability = async (domainName) => {
    try {
      const response = await api.get(`/api/domains/check-availability?domain=${domainName}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };
  export const getRole = async () => {
    try {
      console.log('Making role check API call');
      const response = await api.get('/api/user/role');
      console.log('Role check response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Role check failed:', {
        error,
        response: error.response,
        status: error.response?.status
      });
      return { isAdmin: false };
    }
  };
export const registerDomainOld = async (domain) => {
    try {
      const response = await api.post('/api/domains/register', { domain });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };

  export const registerDomainNext = async (domain, paymentId) => {
    try {
      const response = await api.post('/api/domains/register', { 
        domain,
        payment_id: paymentId // Include payment ID with registration
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

// api.js
export const getAllDomains = async (page = 1, pageSize = 10) => {
  try {
    const response = await api.get('/api/domains', {
      params: {
        page,
        page_size: pageSize
      }
    });
    return {
      data: response.data.data,
      total: response.data.total,
      page: response.data.page,
      pageSize: response.data.page_size
    };
  } catch (error) {
    throw error;
  }
};

export const getProfile = async () => {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', supabase.auth.id)
    .single();
  
  if (error) throw error;
  return data;
};

export const updateProfile = async (profileData) => {
  const { data, error } = await supabase
    .from('profiles')
    .upsert({ id: supabase.auth.id, ...profileData });
  
  if (error) throw error;
  return data;
};

export const checkBalance = async () => {
    try {
      const response = await api.get('/api/payments/balance');
      return response.data.balance;
    } catch (error) {
      console.error('Error checking balance:', error);
      throw error;
    }
  };
  
  export const addBalance = async (amount) => {
    try {
      const response = await api.post('/api/payments/add-balance', { amount });
      return response.data;
    } catch (error) {
      console.error('Error adding balance:', error);
      throw error;
    }
  };

  export const processPayment = async (paymentData) => {
    try {
      const response = await api.post('/api/payments/process', {
        amount: paymentData.amount,
        domainName: paymentData.domainName,
        paymentType: paymentData.paymentType,
        upiId: paymentData.upiId  // Include UPI ID in the request
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  export const checkPaymentStatus = async (paymentId) => {
    try {
      const response = await api.get(`/api/payments/status/${paymentId}`);
      return {
        verified: response.data.status === 'completed',
        failed: response.data.status === 'failed',
        status: response.data.status
      };
    } catch (error) {
      throw error;
    }
  };
  
  export const listPendingPayments = async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value);
        }
      });
      const response = await api.get(`/api/admin/payments?${queryParams}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  export const verifyPayment = async (paymentId, update) => {
    try {
      const response = await api.put(`/api/admin/payments/${paymentId}/verify`, update);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
export const registerDomain = async (domain, price, withDubleu=false, paymentId = null) => {
    try {
      const data = { 
        domain,
        price: parseFloat(price),  // Make sure price is sent as a number
        with_dubleu: withDubleu
      };
      if (paymentId) {
        data.payment_id = paymentId;
      }
      const response = await api.post('/api/domains/register', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

export const getDNSRecords = async (domainId) => {
  try {
      const response = await api.get(`/api/dns/${domainId}/records`);
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const createDNSRecord = async (domainId, record) => {
  try {
      console.log(record)
      const response = await api.post(`/api/dns/${domainId}/records`, record);
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const updateDNSRecord = async (domainId, recordId, record) => {
  try {
      const response = await api.put(`/api/dns/${domainId}/records/${recordId}`, record);
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const deleteDNSRecord = async (domainId, recordId) => {
  try {
      const response = await api.delete(`/api/dns/${domainId}/records/${recordId}`);
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const getDomain = async (domainId) => {
  try {
      const response = await api.get(`/api/domains/${domainId}`);
      return response.data;
  } catch (error) {
      throw error;
  }
};